import { createRoot } from "react-dom/client";

import "bootstrap/dist/css/bootstrap.min.css";

// import "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css";

// import "primeflex/primeflex.css";

// import "primereact/resources/themes/bootstrap4-light-blue/theme.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

// import "bootstrap-icons/font/bootstrap-icons.css";

import App from "./App";

import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./auth/AuthProvider";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <AuthProvider>
    <BrowserRouter>
      {/* <AuthProvider> */}
      <App />
      {/* </AuthProvider> */}
    </BrowserRouter>
  </AuthProvider>
);
